/*
 * ОТДЕЛКА ЛАЙТА ПО МАКЕТУ ВЛАДЕЛЬЦА (`s615`, 18.09.2026).
 *
 * Эталон — `docs/05-tasks/mockups/s615/multimessenger_refined.html`. Все числа
 * ниже взяты ОТТУДА, не на глаз: кегли, высоты, скругления, отступы и цвета.
 *
 * ⛔⛔ ПОЧЕМУ ОТДЕЛКА ЖИВЁТ ЗДЕСЬ, А НЕ В САМИХ ЭКРАНАХ. Список диалогов и
 * экран диалога у лайта СВОИ НЕ НАПИСАНЫ — это те же `Ochered` и `Razbor`, что
 * работают в панели (решение `s608`: второй вход одной сборки, компоненты
 * импортом, не копией). Правка их вёрстки утащила бы за собой панель, где
 * карточка со скруглением, свои отступы и свой ритм нужны: там экран лежит на
 * подложке рядом с меню, а не занимает телефон целиком. Поэтому лайт
 * переодевает общий экран СВОИМ слоем, зацепленным за свои классы
 * (`layt-vid`, `layt-spisok`, `layt-dialog` — их ставит `LaytEkran.tsx`).
 *
 * ⛔ ВЕС СЕЛЕКТОРА ЗДЕСЬ ВАЖНЕЕ КРАСОТЫ (урок `s321`: новая одежда карточки
 * проиграла старому скину ПО ВЕСУ СЕЛЕКТОРА и не показалась вовсе). Правила
 * идут парой классов и потому перебивают одиночные утилиты Tailwind; там, где
 * экран ставит стиль АТРИБУТОМ `style` (полоса «Ответ уйдёт от»), стоит
 * `!important` — иначе перебить нечем, и это названо вслух, а не спрятано.
 *
 * ⛔ ПОРЯДОК ДЕТЕЙ У ОБЩИХ ЭКРАНОВ ЗАКРЕПЛЁН ЗДЕСЬ ЧИСЛОМ (`nth-child`).
 * Это сцепка с чужим файлом, и она названа: у `Razbor` пять прямых детей —
 * шапка, полоса маршрута, ряд переключателя, лента, строка ввода. Добавится
 * шестой между ними — отделка съедет, и увидеть это можно только глазом.
 */

/* ── общее ──────────────────────────────────────────────────────────────── */

.layt-vid {
  --m-line: #e4e7ee;
  --m-text: #1f2937;
  --m-muted: #7c879a;
  --m-muted2: #a4adbc;
  --m-accent: #6d43ff;
  --m-navy: #11306b;
  --m-bg: #f4f6fa;
}

/*
 * В УПОР ДО КРАЁВ (владелец, 18.09, `s608`: «в упор до низу, в упор до
 * боков!!!!!!!!!!!»). Прежнее правило снимало рамку у прямого ребёнка обёртки —
 * а карточка лежит ГЛУБЖЕ, внутри самого экрана, и рамка со скруглением
 * оставалась на месте. Снимаем там, где она есть.
 */
.layt-spisok > div > div.overflow-y-auto,
.layt-dialog > div {
  border-radius: 0;
  border-width: 0;
}

/* Линия над списком у макета одна — её даёт ряд вкладок, а не карточка. */
.layt-spisok > div > div.overflow-y-auto {
  margin-top: 0;
}

/* ── шапка лайта ────────────────────────────────────────────────────────── */

.layt-vid > header {
  height: 52px;
  padding: 0 14px;
  gap: 10px;
  border-color: var(--m-line);
}

.layt-vid > header > span {
  font-size: 17px;
  font-weight: 650;
  letter-spacing: -0.1px;
  color: var(--m-text);
}

.layt-vid > header > button,
.layt-vid > header > a {
  width: 36px;
  height: 36px;
  padding: 0;
  display: grid;
  place-items: center;
  border-radius: 10px;
  color: #59657a;
}

/* ── список диалогов ────────────────────────────────────────────────────── */

/* Поиск и вкладки стоят на БЕЛОМ, одной плитой с шапкой (макет, экран 1). */
.layt-spisok > div {
  background: #fff;
}

.layt-spisok > div > div:has(input[type='search']) {
  padding: 6px 10px 4px;
  gap: 8px;
}

.layt-spisok input[type='search'] {
  height: 32px;
  padding: 0 12px 0 35px;
  border-radius: 17px;
  border-color: var(--m-line);
  background: #fafbfd;
  font-size: 12.5px;
}

.layt-spisok input[type='search']::placeholder {
  color: #9aa5b5;
}

/* Значок лупы держится за левый край поля — поле стало ниже. */
.layt-spisok > div > div:has(input[type='search']) svg {
  left: 12px;
}

/* «Все филиалы» — не кнопка на подложке, а подпись со стрелкой. */
.layt-spisok > div > div:has(input[type='search']) > div:last-child > button {
  height: 32px;
  padding: 0 2px 0 4px;
  font-size: 12.5px;
  color: #59657a;
}

.layt-spisok > div > div.flex-wrap {
  padding: 4px 10px 8px;
  gap: 6px;
  border-bottom: 1px solid var(--m-line);
}

.layt-spisok > div > div.flex-wrap > button {
  height: 28px;
  padding: 0 10px;
  border-radius: 14px;
  font-size: 12.5px;
  line-height: 1;
  color: #606b80;
  border-color: var(--m-line);
}

.layt-spisok > div > div.flex-wrap > button > span {
  font-weight: 650;
  color: #334056;
}

/* Активная вкладка — сплошная фиолетовая, счёт на ней белый. */
.layt-spisok > div > div.flex-wrap > button.bg-ops-primary,
.layt-spisok > div > div.flex-wrap > button.bg-ops-primary > span {
  color: #fff;
}

.layt-spisok > div > div.flex-wrap > button.bg-ops-primary {
  border-color: var(--m-accent);
  background: var(--m-accent);
}

/* Строка диалога: рост 66, значок 42, имя весом 620 (макет). */
.layt-spisok [data-stroka-ocheredi] {
  height: 66px;
  padding: 0 14px;
  gap: 10px;
  border-color: var(--m-line);
}

/*
 * Значок канала: 42 точки и кольцо в полторы, как в макете. Размеры ставит
 * сам компонент АТРИБУТОМ `style` (он считает их числом от переданного
 * размера), поэтому перебить их больше нечем — названо, а не спрятано.
 * Цвет кольца остаётся цветом филиала: он тут несёт смысл.
 */
.layt-spisok [data-stroka-ocheredi] > span.rounded-full {
  width: 42px !important;
  height: 42px !important;
  border-width: 1.5px !important;
}

.layt-spisok [data-stroka-ocheredi] .text-ops-label {
  font-size: 14px;
  font-weight: 620;
  color: var(--m-text);
}

/* Время справа от имени — мельче и глуше самого имени. */
.layt-spisok [data-stroka-ocheredi] .text-ops-micro {
  font-size: 11px;
  color: #9da7b7;
}

/* Вторая линия: «держит …», галочки, фраза. */
.layt-spisok [data-stroka-ocheredi] > span > span:last-child {
  margin-top: 3px;
  font-size: 12px;
  color: #7b869b;
}

.layt-spisok [data-stroka-ocheredi] > span > span:last-child > span:last-child {
  font-weight: 500;
  color: #59657a;
}

/* ── экран диалога ──────────────────────────────────────────────────────── */

/* Шапка собеседницы (первый ребёнок экрана). */
.layt-dialog > div > div:nth-child(1) {
  height: 58px;
  padding: 0 10px 0 8px;
  gap: 6px;
  border-color: var(--m-line);
}

.layt-dialog > div > div:nth-child(1) .text-ops-label {
  font-size: 14px;
  font-weight: 640;
  line-height: 1.1;
}

.layt-dialog > div > div:nth-child(1) .text-ops-micro {
  margin-top: 3px;
  font-size: 11.5px;
  color: #8e98a8;
  gap: 8px;
}

/*
 * ⛔ ПУНКТИР ПОД ТЕЛЕФОНОМ ОСТАВЛЕН НАМЕРЕННО, И ЭТО ОТЛИЧИЕ ОТ МАКЕТА.
 * В макете номер нарисован ровной строкой. В бою под ним пунктир, и это
 * прямое решение владельца (08.09.2026): «клик по самому номеру и есть
 * показать — пунктир зовёт нажать, отдельной кнопки нет». Картинка макета
 * показать приглашение к нажатию не может, а снять его здесь значило бы
 * отменить правило владельца чужой рукой. Одно слово — сниму.
 */

/*
 * Полоса «Ответ уйдёт от» — ровная серая, как в макете. Цвет филиала экран
 * ставит атрибутом `style`, перебить его больше нечем (названо в шапке файла);
 * сам филиал по-прежнему виден цветным значком слева.
 */
.layt-dialog > div > div:nth-child(2) {
  height: 30px;
  padding: 0 12px;
  gap: 7px;
  font-size: 11.5px;
  background: #f0f2f7 !important;
  color: #5f6a80 !important;
  border-color: var(--m-line);
}

.layt-dialog > div > div:nth-child(2) b {
  font-weight: 650;
  color: #31415e;
}

/* Ряд «Этот диалог / Вся хроника» + выбор канала. */
.layt-dialog > div > div:nth-child(3) {
  position: relative;
  height: 48px;
  padding: 0 10px 0 12px;
  gap: 2px;
  border-color: var(--m-line);
}

/*
 * Подложка сегмента. В макете это серая пилюля, внутри которой две равные
 * половины; у экрана обёртки нет — рисуем её фоном самого ряда, под кнопками.
 */
.layt-dialog > div > div:nth-child(3)::before {
  content: '';
  position: absolute;
  left: 12px;
  right: 12px;
  top: 7px;
  height: 34px;
  border-radius: 17px;
  background: #f5f6f9;
}

/* Есть кнопка выбора канала — подложка кончается до неё. */
.layt-dialog > div > div:nth-child(3):has(> button:nth-child(3))::before {
  right: 62px;
}

.layt-dialog > div > div:nth-child(3) > button:nth-child(1),
.layt-dialog > div > div:nth-child(3) > button:nth-child(2) {
  position: relative;
  z-index: 1;
  flex: 1 1 0;
  min-width: 0;
  height: 28px;
  padding: 0 8px;
  border-radius: 14px;
  font-size: 12.2px;
  color: #6a7589;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.layt-dialog > div > div:nth-child(3) > button.bg-ops-primary {
  color: #fff;
  box-shadow: 0 1px 3px rgba(84, 53, 210, 0.22);
}

.layt-dialog > div > div:nth-child(3) > button:nth-child(3) {
  position: relative;
  z-index: 1;
  height: 34px;
  min-width: 48px;
  padding: 0 8px;
  border-radius: 17px;
  border-color: #daddea;
  background: #fff;
  color: #5f6a7f;
}

/* Лента. */
.layt-dialog > div > div:nth-child(4) {
  padding: 10px 14px 18px;
  background: var(--m-bg);
}

/* Пузырь: кегль 14, хвост у своего угла — 6 точек (макет). */
.layt-dialog > div > div:nth-child(4) .rounded-ops-lg {
  max-width: 76%;
  padding: 9px 12px 7px;
  border-radius: 16px;
  font-size: 14px;
  line-height: 1.25;
}

.layt-dialog > div > div:nth-child(4) .rounded-ops-lg.self-end {
  border-bottom-right-radius: 6px;
}

.layt-dialog > div > div:nth-child(4) .rounded-ops-lg.self-start {
  border-bottom-left-radius: 6px;
}

.layt-dialog > div > div:nth-child(4) .rounded-ops-lg .text-ops-micro {
  margin-top: 4px;
  font-size: 10.5px;
  color: #94a0b0;
}

/* Разделитель дня. */
.layt-dialog > div > div:nth-child(4) .rounded-ops-pill {
  border-radius: 12px;
  padding: 3px 10px;
  font-size: 10.5px;
  color: #8d98a8;
  border-color: var(--m-line);
}

/* Строка ввода. */
.layt-dialog > div > div:nth-child(5) {
  padding: 7px 10px 9px;
  background: #fff;
  border-color: var(--m-line);
}

.layt-dialog > div > div:nth-child(5) textarea,
.layt-dialog > div > div:nth-child(5) input[type='text'] {
  min-height: 48px;
  border-radius: 24px;
  border-color: #dce1ea;
  font-size: 13.5px;
  box-shadow: 0 1px 4px rgba(25, 35, 65, 0.05);
}

.layt-dialog > div > div:nth-child(5) button[aria-label] {
  color: #66758c;
}

/*
 * ⛔ КРУГ СПРАВА — ФИОЛЕТОВЫЙ В ОБОИХ СОСТОЯНИЯХ, И ЭТО НАЗВАНО ВСЛУХ.
 * В макете справа стоит фиолетовый круг отправки. В бою на его месте живёт
 * микрофон: правило `s605` «микрофон виден всегда» и `s608` «одна кнопка —
 * микрофон подменяется отправкой» приняты владельцем и снимать их эта сессия
 * не вправе (это был бы урезанный объём, §14). Поэтому от макета берётся
 * ОДЕЖДА круга, а что внутри — решает состояние поля: пусто — микрофон, есть
 * слова — самолётик.
 */
.layt-dialog
  > div
  > div:nth-child(5)
  button[aria-label='Надиктовать ответ']:not(.bg-ops-danger) {
  background: var(--m-accent);
  color: #fff;
  box-shadow: 0 4px 10px rgba(109, 67, 255, 0.25);
}

/*
 * ⛔⛔ ЦВЕТ «ИДЁТ ЗАПИСЬ» НЕ ПЕРЕБИВАЕТСЯ, И ЭТО ПОЙМАНО ЖАЛОБОЙ ВЛАДЕЛЬЦА
 * (18.09.2026: «запись тоже не работает, я нажал "разрешить" но она не
 * реагирует больше»). Первая редакция красила круг фиолетовым БЕЗУСЛОВНО и
 * весом в три класса — а экран сообщает о начавшейся записи единственным
 * способом: красит ту же кнопку красным одиночным классом. Диктовка шла, но
 * выглядела ровно как до нажатия, и это неотличимо от «кнопка мертва».
 * Размер круга общий для обоих состояний, цвет — только у нерабочего.
 */
.layt-dialog > div > div:nth-child(5) button[aria-label='Надиктовать ответ'] {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

/* ── шторки ─────────────────────────────────────────────────────────────── */

/*
 * Меню «⋮» на телефоне открывается СНИЗУ (макет, экран 3: «Меню ⋮ открывается
 * снизу на телефоне»). У экрана это выпадающий список, приклеенный к правому
 * верхнему углу: на столе он на месте, на 390 — прижат к краю и накрывает
 * собеседницу. Переносим низом, шириной во весь телефон.
 */
.layt-dialog > div > div:nth-child(1) > div.absolute {
  position: fixed;
  left: 8px;
  right: 8px;
  bottom: 8px;
  top: auto;
  margin: 0;
  min-width: 0;
  border-radius: 18px;
  border: 0;
  box-shadow: 0 16px 40px rgba(25, 35, 65, 0.12);
}

.layt-dialog > div > div:nth-child(1) > div.absolute > button {
  height: 48px;
  padding: 0 14px;
  gap: 8px;
  font-size: 13.5px;
}

/* Подложка под шторкой — притенение, как в макете (у экрана она прозрачная). */
.layt-dialog > div > div:nth-child(1) > button.fixed {
  background: rgba(27, 35, 54, 0.3);
}

/* Общая нижняя шторка (выбор канала, шаблон, отложить…). */
.layt-dialog .fixed.inset-0 > div {
  margin: 0 8px 8px;
  border-radius: 18px;
  padding: 0;
  box-shadow: 0 16px 40px rgba(25, 35, 65, 0.12);
}

.layt-dialog .fixed.inset-0 > div > div:first-child {
  height: 48px;
  margin: 0;
  padding: 0 16px;
  border-bottom: 1px solid var(--m-line);
  font-size: 13px;
  font-weight: 650;
}

.layt-dialog .fixed.inset-0 > div > button {
  height: 60px;
  padding: 0 14px;
  border-radius: 0;
}

.layt-dialog .fixed.inset-0 > div > button + button {
  border-top: 1px solid #f0f2f5;
}

/*
 * Строки меню «⋮» — с разделителем, как в макете. Селектор по ЛЮБОМУ соседу,
 * а не по паре кнопок: первый ход («Открыть карточку») — ссылка, а не кнопка,
 * и правило «кнопка + кнопка» оставляло его без линии. Заодно этой же линией
 * подчёркнут заголовок шторки — своей у него нет намеренно, иначе под ним
 * вышла бы двойная.
 */
.layt-dialog > div > div:nth-child(1) > div.absolute > * + * {
  border-top: 1px solid #f0f2f5;
}
